<template>
  <div class="delete-customer" />
</template>

<script>
export default {
  name: 'Delete',
  mounted() {
    this.$buefy.dialog.confirm({
      title: 'Borrar cliente',
      message: '¿Estas seguro de borrar este cliente?',
      confirmText: 'Borrar',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => {
        this.$store.dispatch('customers/deleteSingle', this.$route.params.customer).then(() => {
          this.$success({ message: 'El cliente se eliminó correctamente' });
          this.$router.push({ name: 'Customers', query: { page: 1, size: 20 } });
        }).catch(() => {
          this.$danger({ message: 'Ocurrió un error al momento de borrar' });
        });
        this.$router.push({ name: 'Customers', query: { page: 1, size: 20 } });
      },
      onCancel: () => {
        this.$router.push({ name: 'Customers', query: { page: 1, size: 20 } });
      },
    });
  },
};
</script>

<style scoped>
</style>
